{
  "salon-search-result-page": {
    "buttons": {
      "book-appointment": "BOOK APPOINTMENT",
      "explore": "EXPLORE",
      "show-more": "SHOW MORE"
    },
    "text": {
      "salon-around": "Salons nearby"
    }
  }
}
